export enum PostRegApplicationStatus  {
    NEW = 'NEW',
    IN_PROCESS = 'IN_PROCESS',
    COMPLETED = 'COMPLETED',
    /** Every event of the application was rejected. */
    REJECTED = 'REJECTED',
}

export const POST_REG_APPLICATION_STATUS_MAP: Map<PostRegApplicationStatus, string> = new Map([
    [PostRegApplicationStatus.NEW, 'New'],
    [PostRegApplicationStatus.IN_PROCESS, 'In process'],
    [PostRegApplicationStatus.COMPLETED, 'Completed'],
    [PostRegApplicationStatus.REJECTED, 'Rejected'],
])
